import { GlobalCanvas, SmoothScrollbar } from "@14islands/r3f-scroll-rig";
import "@14islands/r3f-scroll-rig/css";
import { Environment } from "@react-three/drei";
import React, { Suspense, useRef, useState } from "react";

import hdrUrl from "../env/empty_warehouse_01_1k.hdr?url";
import Article from "./Article";
import Lens from "./Lens";

const App = () => {
  const eventSource =
    useRef<HTMLDivElement>() as React.MutableRefObject<HTMLDivElement>;
  const [enabled, setEnabled] = useState(true);

  return (
    <div ref={eventSource}>
      <GlobalCanvas
        // shader errors are hidden by default which speeds up compilation
        debug={false}
        // scaleMultiplier is a scroll-rig setting to scale the entire scene
        scaleMultiplier={0.01}
        // All other props on the R3F Canvas is supported:
        eventSource={eventSource}
        eventPrefix="client"
        flat // disable toneMapping since we have editorial images
        camera={{ fov: 14 }}
        style={{ pointerEvents: "none", zIndex: -1 }}
      >
        {globalChildren => (
          <Lens>
            <Suspense fallback="">
              <Environment files={hdrUrl} />
              {globalChildren}
            </Suspense>
          </Lens>
        )}
      </GlobalCanvas>
      <SmoothScrollbar
        enabled={enabled}
        config={{ syncTouch: true }} // Lenis setting to force smooth scroll on touch devices
      />

      <Article enabled={enabled} setEnabled={setEnabled} />
    </div>
  );
};

export default App;

// OLD LENS
// {globalChildren => (
//     <Lens>
//       <WebGLBackground />
//       <Suspense fallback="">
//         <Environment files={hdrUrl} />
//         {globalChildren}
//       </Suspense>
//     </Lens>
//   );}
